import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type LoginState = {
  user: {
    email: string;
    password: string;
    phone?: string;
  };
};

const getInitialState = (): LoginState => ({
  user: {
    email: '',
    password: '',
    phone: '',
  },
});

const loginSlice = createSlice({
  name: 'login',
  initialState: getInitialState(),
  reducers: {
    setLoginValue: (
      state,
      action: PayloadAction<{ name: string; value: string }>
    ) => {
      const { name, value } = action.payload;
      return { user: { ...state.user, [name]: value } };
    },
  },
  selectors: {
    selectLogin: (state) => state,
  },
});

export const {
  reducer: loginReducer,
  actions: { setLoginValue },
  selectors: { selectLogin },
} = loginSlice;

export type LoginActions = ReturnType<typeof setLoginValue>;
